/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/imagesloaded.pkgd.min.js');
// require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
// require('./vendor/slick-slider');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
// require('./vendor/waypoint');
// require('./vendor/waypoint-animate');

// Sliders
// require('./app/sliders/card-slider');

// ScrollTrigger
// require('./app/scrollTrigger);

// App Requires
// require('./app/config');
// require('./app/helpers');
// require('./app/primary-navigation');
require('./app/header');
require('./app/bootstrap-inits');
require('./app/container-sizing');
require('./app/events');
require('./app/timeline');
require('./app/blog');
require('./app/our-gardens');
require('./app/garden-explorer');
require('./app/dropdown-expand');
require('./app/accordion');
require('./app/hero');
require('./app/blocks/schedule');
require('./app/blocks/gallery');
require('./app/tickets-modals');

$(window).on('load', function () {
    if($(window).width() < 1200) {
        setTimeout(function () {
            $(window).resize();
        }, 1000);
    }
});

$('.video-modal').on('hidden.bs.modal', function () {
    let iframeScr = $(this).find('iframe').attr('src');
    $(this).find('iframe').attr('src', iframeScr);
    $(this).find('iframe').attr('src', iframeScr);
});